/**
 * Converts a hex color to hex with alpha transparency
 * Copied from nuxt-widget for consistency
 *
 * @param hex - Hex color (e.g., '#91A0EB' or '91A0EB')
 * @param percentage - Opacity percentage (0-100)
 * @returns Hex color with alpha channel (e.g., '#91A0EBBF' for 75%)
 */
export const getTransparentColor = (hex: string, percentage: number) => {
  // Strips leading '#' and normalizes short hex to full length
  let clean = hex.replace(/^#/, '')
  if (clean.length === 3) {
    clean = clean
      .split('')
      .map((ch) => ch + ch)
      .join('')
  }
  if (clean.length !== 6) {
    throw new Error('hexWithAlpha: invalid hex colour supplied')
  }

  // Clamp percentage and convert to 0-255
  const alpha = Math.round((255 * Math.min(Math.max(percentage, 0), 100)) / 100)

  // Convert alpha to 2-digit hex and concatenate
  const alphaHex = alpha.toString(16).padStart(2, '0').toUpperCase()

  return `#${clean.toUpperCase()}${alphaHex}`
}

export const isHexColor = (value: string | null | undefined) => {
  const normalized = value?.trim()
  if (!normalized) return false
  return /^#(?:[0-9A-Fa-f]{3}){1,2}$/.test(normalized)
}

export const normalizeHexColor = (value: string | null | undefined, fallback: string) => {
  const normalized = value?.trim()
  return isHexColor(normalized) ? normalized : fallback
}
